// Cards-list payload schema (`ItemsData<Card>`) shared by every market cards endpoint.

import { cardSchema, itemsDataSchema } from './common';

export const cardsListSchema = itemsDataSchema(cardSchema);
